import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UserUtils from '../lib/UserUtils'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Group from './sidebar/Group'
import SortContainer from './SortContainer'
import GroupForm from './sidebar/GroupForm'
import { sort } from '../lib/ContentUtils'
import Icon from './Icon'

@connect(state => ({types: state.types, site: state.sites.current}))
export default class extends Component {
  static contextTypes = {
    editing: PropTypes.bool
  }

  state = {
    groupModel: null,
    groupForm: false
  }

  didSort = (groups) => {
    groups.forEach((group, i) => {
      group.display_order = i
    })
  }

  newGroup = (e) => {
    e.preventDefault()
    this.setState({groupForm: true, groupModel: {}})
  }

  editGroup = (group, e) => {
    e.preventDefault()
    this.setState({groupForm: true, groupModel: group})
  }

  render () {
    const {site} = this.props
    const {editing} = this.context
    const {types} = this.props
    const canCreate = UserUtils.can(site, 'create', 'content_type')
    const ungrouped = types.filter(type => !type.group_id)
    const groups = sort(site.groups)

    return <nav>
      <SortContainer
        itemType='GROUPS'
        items={groups}
        didSort={this.didSort}
        renderItem={group =>
          <Group key={group.id}
            group={group}
            items={sort(types.filter(type => type.group_id === group.id))}
            path={`/${site.id}/content`}
            onEdit={this.editGroup.bind(null, group)}
          />
        }
      />
      {(ungrouped.length > 0) &&
        <Group
          group={{name: editing ? 'No Group' : '', id: null}}
          items={ungrouped}
          path={`/${site.id}/content`}
        />
      }
      {canCreate &&
        <div className='sidebar-action'>
          {editing
            ? <a role='button' onClick={this.newGroup}>
              <Icon name='plus' /> New Group
            </a>
            : <Link to={`/${site.id}/content/new`}>
              <Icon name='plus' /> Content Type
            </Link>
          }
        </div>
      }
      <GroupForm
        showing={this.state.groupForm}
        group={this.state.groupModel}
        onDismiss={() => this.setState({groupForm: false})}
      />
    </nav>
  }
}



// WEBPACK FOOTER //
// ./app/components/SidebarContent.js